var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPLOAD_COD_REMITTANCE_REQUEST, uploadCodRemittanceSuccess, uploadCodRemittanceFailure } from "../../actions";
import APIIN from "../../../utils/APIIN";
const uploadCodRemittanceFile = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append("file", action.payload);
        try {
            APIIN.formUpload("/report/admin/upload/cod-remittance", { file: action.payload })
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
    }));
});
function* uploaCodRemittanceFileWorker(action) {
    try {
        const response = yield call(uploadCodRemittanceFile, action);
        yield put(uploadCodRemittanceSuccess(response));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            yield put(uploadCodRemittanceFailure(error.response.data.message));
        }
        else {
            yield put(uploadCodRemittanceFailure("An error occurred while uploading the file"));
        }
    }
}
export function* watchUploadCodRemittanceFile() {
    yield takeLatest(UPLOAD_COD_REMITTANCE_REQUEST, uploaCodRemittanceFileWorker);
}
